exports.ByName = {
  IncludeAll: { Name: 'include_all', Id: 1 },
  ExcludeAll: { Name: 'exclude_all', Id: 2 },
  Custom: { Name: 'custom', Id: 3 }
};

exports.ById = {
  1: { Name: 'include_all', Id: 1 },
  2: { Name: 'exclude_all', Id: 2 },
  3: { Name: 'custom', Id: 3 }
};